import { z } from 'zod';
import { AnchorTypes } from '../constants/anchors.const';
import { SafetyViolationTypes } from '../constants/safety.const';

// Schemas (source of truth) — pure validation, no transforms
export const baseStaticAnchorSchema = z.object({
	projectId: z.string(),
	areaId: z.string(),
	anchorId: z.string(),
	anchorNick: z.string(),
	anchorType: z.enum(AnchorTypes),
	safetyViolations: z.array(z.enum(SafetyViolationTypes)).default([]),
});

// Types (derived from schemas)
export type IBaseStaticAnchor = z.infer<typeof baseStaticAnchorSchema>;
